import { createSlice } from "@reduxjs/toolkit"
import axios from "axios"

const initialState = {
    recentWinnersLoading: false,
    recentWinnersData: [],
    recentWinnersErrorMessage: null,
}

export const luckyDrawSlice = createSlice({
    name: "luckyDraw",
    initialState,
    reducers: {
        recentWinnersRequest: (state) => {
            state.recentWinnersLoading = true
            state.recentWinnersErrorMessage = null
        },
        recentWinnersSuccessAction: (state, action) => {
            state.recentWinnersLoading = false
            state.recentWinnersData = action.payload
            state.recentWinnersErrorMessage = null
        },
        recentWinnersFailAction: (state, action) => {
            state.recentWinnersLoading = false
            state.recentWinnersErrorMessage = action.payload
        },
    },
})

// Action creators
export const {
    recentWinnersRequest,
    recentWinnersSuccessAction,
    recentWinnersFailAction,
} = luckyDrawSlice.actions

// Selectors
export const getRecentWinnersLoading = (state) => state.luckyDraw.recentWinnersLoading
export const getRecentWinnersData = (state) => state.luckyDraw.recentWinnersData
export const getRecentWinnersErrorMessage = (state) => state.luckyDraw.recentWinnersErrorMessage

// Thunk — recent lucky-draw (VIP campaign prize) winners for the home banner.
// Errors are swallowed so a failure just leaves the banner empty (it's hidden).
export const doGetRecentWinners = (limit = 8) => {
    return async (dispatch) => {
        dispatch(recentWinnersRequest())
        try {
            const response = await axios.get(`/api/customer/lucky-draw/recent-winners?limit=${limit}`)
            dispatch(recentWinnersSuccessAction(response.data.data || []))
            return { payload: response.data.data }
        } catch (error) {
            const errorMessage = error.response?.data?.message || error.message || "Network error occurred"
            dispatch(recentWinnersFailAction(errorMessage))
        }
    }
}

export default luckyDrawSlice.reducer
